var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoUpcomingMentorClassess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#F5F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6181 16.6602H20.9141V36.4598H49.6181V16.6602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.596 17.0039H20.8828V17.5821H49.596V17.0039Z",
    fill: "#ACACAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1487 37.0898H34.3477V58.3408H36.1487V37.0898Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1266 58.4244L21.9805 58.4176L33.639 36.7461L35.2274 37.5917L24.1266 58.4244Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.386 58.44L48.5321 58.4332L36.8736 36.7617L35.2852 37.6074L46.386 58.44Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5692 39.9063L31.9297 39.92L32.1811 39.4492L38.3246 39.4515L38.5692 39.9063Z",
    fill: "#ACACAC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.531 46.6232L27.75 48.2461L34.9478 51.7101L35.7288 50.0873L28.531 46.6232Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8284 49.967L35.6094 51.5898L42.8071 48.1258L42.0261 46.503L34.8284 49.967Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4876 14H18.0469V16.9872H52.4876V14Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43 13H28V16H43V13Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4408 36.4648H18V39.452H52.4408V36.4648Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5576 34.4609H41.8438V34.9843H47.5576V34.4609Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5576 34.9766H41.8438V36.4576H47.5576V34.9766Z",
    fill: "#666666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2362 39.4527H44.5224L41.8438 36.4609H47.5645L50.2362 39.4527Z",
    fill: "#BABABA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUpcomingMentorClassess);
export default __webpack_public_path__ + "static/media/NoUpcomingMentorClassess.66dcf715812d6cb4ec1c2ae63aabe01f.svg";
export { ForwardRef as ReactComponent };